import clsx from 'clsx';
import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import BeatLoader from 'react-spinners/BeatLoader';

import { useSubscribeToNewsletter, useUnsubscribeFromNewsletter } from '../../../hooks';
import {
  create_user_path,
  newsletter_post_signup_path,
  static_privacy_path,
} from '../../../routes';
import LockedLeadCaptureForm from '../../shared/LockedLeadCaptureForm';
import styles from './styles';

const DARK_MODE_SPINNER_COLOR = '#fff';

const NewsletterSignUp = ({
  currentUser,
  gdpr,
  gdprColorScheme,
  isSubscribed,
  newsletterId,
  newsletterName,
}) => {
  const { mutate: subscribeToNewsletter, isLoading: isFollowNewsletterLoading } =
    useSubscribeToNewsletter();
  const { mutate: unsubscribeFromNewsletter, isLoading: isUnFollowNewsletterLoading } =
    useUnsubscribeFromNewsletter();

  useEffect(() => {
    // @ts-expect-error initializes lead forms with js function outside React app
    // TODO: Update these methods to explitly export instead of using sprockets
    addLeadCaptures(); // eslint-disable-line
  }, []);

  return (
    <div className={styles.newsletterSignUp}>
      {currentUser ? (
        isSubscribed ? (
          <Button
            className={clsx(styles.toggleButton, styles.unsubscribeButton, 'unsub-btn')}
            onClick={() => {
              unsubscribeFromNewsletter({ newsletter_id: newsletterId });
            }}
            disabled={isUnFollowNewsletterLoading}
          >
            {isUnFollowNewsletterLoading ? (
              <BeatLoader color={DARK_MODE_SPINNER_COLOR} size={10} />
            ) : (
              <>You are Subscribed</>
            )}
          </Button>
        ) : (
          <Button
            className={clsx(styles.toggleButton, styles.subscribeButton, 'sub-btn')}
            onClick={() => {
              subscribeToNewsletter({ newsletter_id: newsletterId });
            }}
            disabled={isFollowNewsletterLoading}
          >
            {isFollowNewsletterLoading ? (
              <BeatLoader color={DARK_MODE_SPINNER_COLOR} size={10} />
            ) : (
              <>Subscribe to {`${newsletterName}`}</>
            )}
          </Button>
        )
      ) : (
        <>
          {gdpr && (
            <div className={`marketing-opt-in-container ${gdprColorScheme} `}>
              <label className="marketing-opt-in">
                <span className="form-control-text">
                  Get Breaking News, Relevant Stories, and Special Event &amp; Editorial Invites
                </span>
                <input type="checkbox" value="1" name="user[opt_in]" className="opt-in" required />
                <span className="checkbox-fill"></span>
              </label>
            </div>
          )}
          <LockedLeadCaptureForm
            buttonText="Sign Up"
            endpointUri={create_user_path({ newsletter_ids: [newsletterId] })}
            redirectUri={newsletter_post_signup_path({ id: newsletterId })}
            leadType={`${newsletterName.replace(' ', '_').toLowerCase()}_newsletter_lead_type`}
            trackingProps={{ 'lead-details': `{ "newsletter_name": "${newsletterName}" }` }}
          />
          <div className={styles.privacy}>
            By Providing Your Email, You Agree To The Information’s{' '}
            <a href={static_privacy_path()}>Privacy Policy</a>
          </div>
        </>
      )}
    </div>
  );
};

export default NewsletterSignUp;
